import React from 'react'
import { Badge } from '@carla/flora'

const INSPECTION_TYPE_BADGE: Record<string, { type: 'splash' | 'success' | 'info' | 'warning' }> = {
  PICKUP: { type: 'splash' },
  DELIVERY_PREP: { type: 'info' },
  PRODUCTION: { type: 'success' },
  MAINTENANCE: { type: 'warning' },
}

export default function InspectionTypeBadge({ value }: { value: string }) {
  const style = INSPECTION_TYPE_BADGE[value] ?? { type: 'splash' as const }
  return <Badge type={style.type}>{value}</Badge>
}
